import { Schema } from "rsuite";

const { Model, Types } = Schema;

export type BlackListEmailAddFormType = {
  domainName?: string,
};

export const BlackListEmailAddFormSchema = Model({
  domainName: Types.StringType().isRequired("Domain name is required"),
});

export const BlackListEmailAddDefaultValues: BlackListEmailAddFormType = {
  domainName: "",
};
